import { render, staticRenderFns } from "./SupervisorsReports.vue?vue&type=template&id=93227702"
import script from "./SupervisorsReports.vue?vue&type=script&lang=js"
export * from "./SupervisorsReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports